import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AppCoreContext } from '@/providers/core-provider';
import { useFlow } from './use-flow';

export function useCore() {
  const { setFlow } = useFlow();
  const { lenovoId } = useContext(AppCoreContext);
  const { t, i18n } = useTranslation();

  return { setFlow, lenovoId, t, lang: i18n.language };
}
